import { twMerge } from 'tailwind-merge';
import Spinner from '@/components/Spinner';
import { MoveFileIcon } from '@/icons';
import { classes } from './utils';

export type MoveButtonProps = {
  disabled?: boolean;
  isSaving?: boolean;
  className?: string;
  onMove: () => Promise<void>;
};

export default function MoveButton({
  disabled,
  isSaving,
  className,
  onMove,
}: MoveButtonProps) {
  return (
    <button
      disabled={disabled}
      className={twMerge(
        classes.move,
        disabled && !isSaving && classes.hidden,
        className
      )}
      onClick={onMove}>
      {isSaving ? <Spinner size={20} /> : <MoveFileIcon />}
      <span>{isSaving ? 'Moving...' : 'Move'}</span>
    </button>
  );
}
